import type { ReactElement } from 'react';

import { IntentDetection, intentDetectionApi } from 'apis/intentDetection';

type Props = {
  render: (intentDetections: IntentDetection[]) => ReactElement;
};

export function IntentDetectionsFetch({ render }: Props): JSX.Element {
  const { data } = intentDetectionApi.useReadIntentDetectionsQuery({});
  return render(data?.intentDetections ?? []);
}
